


import React, { useState, useEffect } from 'react';
import { PoweroffOutlined } from '@ant-design/icons';
import { Button, DatePicker, Space } from 'antd';
import Table from 'react-bootstrap/Table';
import $ from 'jquery';

export default function Resulthistory() {
  const [isLoading, setIsLoading] = useState(true);
  const [iframeContent, setIframeContent] = useState(null);
  const [scrolltopdata, setscrolltopdata] = useState('');

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY < 1) {
        setscrolltopdata('');
      } else {
        setscrolltopdata('scrolled');
      }
    });
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://adminvip.shreejii.club/public/results-data`);


        
        console.warn("response for result", response.text);

        const result = await response.text();
        setIframeContent(result);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  $('#submitfilter').on('click', function () {
    window.location.reload()
  });

  const Buttonrelod = () => {

    window.location.reload();
  };
  return (
    <>

        <section id="Help" className=''>
          <div  style={{height:"100vh",margin:"55px 0"}}>
            {/* <button className={`btn-primary btn_getresult ${scrolltopdata}`} onClick={Buttonrelod}>Search</button> */}
            <iframe src="https://adminvip.shreejii.club/public/results-data" height="100%" width="100%" title="Iframe Example"></iframe>
          </div>
        </section>
    
    </>

  )
}
